import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/admin/Login.vue'
import store from '../store/index';
import FormProvider from '../views/providers/Form.vue'
import ListProvider from '../views/providers/List.vue'
import EditProvider from '../views/providers/Edit.vue'
import ShowProvider from '../views/providers/Show.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/providers/form',
    name: 'providers/form',
    component: FormProvider,
    //meta: { requiresAuth: true },
  },
  {
    path: '/providers/list',
    name: 'providers/list',
    component: ListProvider,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/providers/edit/:id?',
    name: 'providers/edit',
    props: true,
    component: EditProvider,
    meta: { requiresAuth: true },
  },
  {
    path: '/providers/show',
    name: 'providers/show',
    props: true,
    component: ShowProvider,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some((record) => record.meta.requiresAdmin);
  const isAuthenticated = store.getters.isAuthenticated;
  const isAdmin = store.getters.isAdmin; // Obtener el estado de administrador

  if (requiresAuth && !isAuthenticated) {
    next('/login'); // Redirige al login si no está autenticado
  } else if (requiresAdmin && !isAdmin) {
    next('/'); // Redirige al Dashboard o home si no es admin
  } else if (!requiresAuth && isAuthenticated && to.path === '/login') {
    next('/'); // Redirige a Dashboard si ya está autenticado y está intentando acceder al login
  } else {
    next(); // Permite el acceso para rutas públicas
  }
});

export default router
